import { SignalDispatcher, SimpleEventDispatcher, EventDispatcher } from "strongly-typed-events";
import { UsuarioActual } from '@/views/a-login/login-controlador';
import router from '@/__env/router.index';
import { Curso } from '@/__env/lib/Cursos';
import { Utiles } from '@/__env/pluggins/event-bus';

export class ControladorDeInicio
{
    public get Usuario() { return UsuarioActual; }



    public readonly Vista = new Vista();

    Editar( item: Curso )
    {
        this.Vista.Query = 'id=' + item.Id;
        this.Vista.Modo = 'crear';
    }

    Abrir( item: Curso )
    {
        this.Vista.Query = 'id=' + item.Id;
        this.Vista.Modo = 'detalles';
    }
}

type Opcion = {
    Icono?: string,
    Titulo?: string,
    Subtitulo?: string,
    Modo?: string,
    Resaltado?: boolean,
    Oculto?: boolean,
    Accion?: Function,
    Tipo: 'opcion' | 'titulo',
};


type Modo =
    string |
    'vacio' |
    'detalles' |
    'lista' |
    'crear'

    ;

type SubModo =
    'vacio' |
    'configuracion-usuario' |
    'notificaciones';
'chat'
    ;

type Estado = 'iniciado' | 'cargando' | 'error' | 'mod';
type Buscador =
    'vacio' |
    'ninguno';

class Vista
{
    public readonly Titulo: string = 'Cursos';
    public get SubTitulo(): string
    {
        let e = this.Opciones.find( x => x.Modo == this.modo );
        if ( e )
            return e.Titulo;
    }

    public Opciones: Opcion[] = [

        { Tipo: 'titulo', Titulo: '' },
        { Tipo: 'opcion', Icono: 'book-open-page-variant', Modo: 'lista', Titulo: 'Cursos creados' },
        { Tipo: 'opcion', Icono: '', Modo: 'crear', Titulo: 'Crear', Oculto: true },
        { Tipo: 'opcion', Icono: '', Modo: 'detalles', Titulo: 'Detalles', Oculto:true },


    ];

    protected modo: Modo = 'creados';
    get Modo(): Modo { return this.modo; }
    set Modo( m: Modo ) { this.modo = m; this._onModo.dispatch(); this.Query =  this.query + '&m=' + this.modo; }
    private _onModo = new SignalDispatcher();
    public get onModo() { return this._onModo.asEvent(); }

    protected query: string = '';
    public set Query( x: string )
    {
        this.query = x;
        Utiles.setQuery( this.query );
    }
    private _onEditarQuery = new SimpleEventDispatcher<string>();
    public get onEditarQuery() { return this._onEditarQuery.asEvent(); }

    protected submodo: SubModo = 'vacio';
    get SubModo(): SubModo { return this.submodo; }
    set SubModo( m: SubModo ) { this.submodo = m; this._onSubModo.dispatch(); }
    private _onSubModo = new SignalDispatcher();
    public get onSubModo() { return this._onSubModo.asEvent(); }

    protected menuAbierto: boolean = true;
    get MenuAbierto(): boolean { return this.menuAbierto; }
    set MenuAbierto( m: boolean ) { this.menuAbierto = m; this._onMenuAbierto.dispatch(); }
    private _onMenuAbierto = new SignalDispatcher();
    public get onMenuAbierto() { return this._onMenuAbierto.asEvent(); }

    protected estado: Estado = 'cargando';
    get Estado(): Estado { return this.estado; }
    set Estado( m: Estado ) { this.estado = m; this._onEstado.dispatch(); }
    private _onEstado = new SignalDispatcher();
    public get onEstado() { return this._onEstado.asEvent(); }

    protected buscador: Buscador = 'ninguno';
    get Buscador(): Buscador { return this.buscador; }
    set Buscador( m: Buscador ) { this.buscador = m; this._onBuscador.dispatch(); }
    private _onBuscador = new SignalDispatcher();
    public get onBuscador() { return this._onBuscador.asEvent(); }



}

export const Controlador = new ControladorDeInicio();


